import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthGuard } from '@acpgruppe/essp-ui';
import { PermissionGuard } from '@acpgruppe/essp-ui';

const appPathValue = 'partnernav';

@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {
          path: '',
          pathMatch: 'full',
          redirectTo: appPathValue,
        },
        {
          path: 'start',
          pathMatch: 'full',
          redirectTo: appPathValue,
        },
        {
          path: appPathValue,
          canActivate: [AuthGuard, PermissionGuard],
          loadChildren: () =>
            import('./core/core.module').then((l) => l.CoreModule),
        },
      ],
      {  bindToComponentInputs: true },
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
